import {
  NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_FIELD_MAX_LENGTH,
  NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_FIELD_TICKER_MAX_LENGTH,
} from './NewsboardPostProfileHeaderEditTitleField.constants'

export function getNewsboardPostProfileHeaderEditTitleMaxLength(isTicker) {
  return isTicker
    ? NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_FIELD_TICKER_MAX_LENGTH
    : NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_FIELD_MAX_LENGTH
}
